module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('van-cell-group', [_c('van-field', {
    attrs: {
      "type": "password",
      "label": "新密码",
      "placeholder": "请输入密码",
      "input-align": "right",
      "error": _vm.formValidate && !_vm.formData.password
    },
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "type": "password",
      "label": "确认新密码",
      "placeholder": "请再次输入新密码",
      "error": _vm.formValidate && !_vm.formData.password2,
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.password2),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password2", $$v)
      },
      expression: "formData.password2"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "center": "",
      "clearable": "",
      "label": "短信验证码",
      "placeholder": "请输入短信验证码",
      "error": _vm.formValidate && !_vm.formData.code
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", $$v)
      },
      expression: "formData.code"
    }
  }, [_c('van-button', {
    attrs: {
      "slot": "button",
      "size": "small",
      "type": "danger",
      "background-color": "red"
    },
    on: {
      "click": _vm.getCode
    },
    slot: "button"
  }, [_vm._v(_vm._s(_vm.clockSecond > 0 ? _vm.clockSecond + 's获取验证码' : '获取验证码'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [(!_vm.loading) ? _c('van-button', {
    attrs: {
      "type": "danger",
      "round": "",
      "size": "large"
    },
    on: {
      "click": _vm.formSave
    }
  }, [_vm._v("确定")]) : _c('van-button', {
    attrs: {
      "type": "danger",
      "round": "",
      "size": "large"
    }
  }, [_vm._v("确定中...")])], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1751f02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/setting/Password.vue
// module id = 2573
// module chunks = 0